import styled from 'styled-components';
import Modal from '../Modal';

export const StyledMountedModal = styled(Modal)<{ isHidden: boolean }>`
  display: ${(props) => (props.isHidden ? 'none' : 'flex')};
`;
